var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDialogMask),expression:"showDialogMask"}],staticClass:"dialog-mask",class:{ noMask: _vm.isPC }})}
var staticRenderFns = []

export { render, staticRenderFns }